import { Injectable, inject } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivate, Router, RouterStateSnapshot, UrlTree } from '@angular/router';
import { Observable, map, tap } from 'rxjs';
import { UserService } from '../services/user.service';

@Injectable({
  providedIn: 'root'
})
export class MissingFieldsGuard implements CanActivate {
  private router = inject(Router);
  private userService = inject(UserService);
  canActivate(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot): Observable<boolean | UrlTree> | Promise<boolean | UrlTree> | boolean | UrlTree {
      return this.userService.checkMissingFields().pipe(
        map(isMissingFields => isMissingFields === true ? this.router.parseUrl('/missing-fields') : true)
      );
  }

}
